/* eslint-disable no-undef */
import { getParameterByName, isLocalStorage } from './modules/_Utils';
import html2canvas from 'html2canvas';
import 'jquery-mask-plugin/dist/jquery.mask';
import {
    deviceRegistration,
    speedTestStart,
    speedTestComplete,
} from './modules/_speed-test';

let ndtServer,
    server_city,
    server_country,
    speedTestId = '',
    savedDownloadSpeed,
    speedUnits,
    speedRange,
    formattedDate,
    uploadSpeed,
    uploadElapsed,
    uploadSpeedData = [],
    maxUploadSpeed,
    downloadSpeed,
    downloadElapsed,
    downloadSpeedData = [],
    maxDownloadSpeed,
    latency,
    jitter,
    justifiedDownload,
    downloadUnit,
    packetLoss,
    interval,
    intervalDecimal,
    serverURLs,
    serverChosen = false,
    mapiFetched = false;
let circleAmount = 5.5;

const stateAverages = [];

stateAverages.Alabama = 95.87446786;
stateAverages.Alaska = 80.67078832;
stateAverages.Arizona = 87.22305331;
stateAverages.Arkansas = 81.22355163;
stateAverages.California = 119.1314064;
stateAverages.Colorado = 106.417729;
stateAverages.Connecticut = 117.6583242;
stateAverages.Delaware = 131.977609;
stateAverages['District of Columbia'] = 78.9633867;
stateAverages.Florida = 121.2269668;
stateAverages.Georgia = 108.0922519;
stateAverages.Hawaii = 87.01105052;
stateAverages.Idaho = 82.79629064;
stateAverages.Illinois = 106.8445348;
stateAverages.Indiana = 105.8785092;
stateAverages.Iowa = 81.28726073;
stateAverages.Kansas = 86.12817806;
stateAverages.Kentucky = 95.50470195;
stateAverages.Louisiana = 88.13386055;
stateAverages.Maine = 77.83098471;
stateAverages.Maryland = 130.9867257;
stateAverages.Massachusetts = 116.0753554;
stateAverages.Michigan = 95.87152887;
stateAverages.Minnesota = 84.86571945;
stateAverages.Mississippi = 90.27865099;
stateAverages.Missouri = 93.65279392;
stateAverages.Montana = 67.52350453;
stateAverages.Nebraska = 89.64059039;
stateAverages.Nevada = 97.04529706;
stateAverages['New Hampshire'] = 113.9053584;
stateAverages['New Jersey'] = 127.4310367;
stateAverages['New Mexico'] = 76.88544356;
stateAverages['New York'] = 103.8028646;
stateAverages['North Carolina'] = 99.66570995;
stateAverages['North Dakota'] = 93.75604538;
stateAverages.Ohio = 93.1627421;
stateAverages.Oklahoma = 93.87002587;
stateAverages.Oregon = 95.23888285;
stateAverages.Pennsylvania = 107.1006178;
stateAverages['Rhode Island'] = 113.1401186;
stateAverages['South Carolina'] = 110.568855;
stateAverages['South Dakota'] = 49.0959852;
stateAverages.Tennessee = 102.4921859;
stateAverages.Texas = 117.3463751;
stateAverages.Utah = 104.1660977;
stateAverages.Vermont = 82.88031852;
stateAverages.Virginia = 121.0168052;
stateAverages.Washington = 98.63475509;
stateAverages['West Virginia'] = 73.21794161;
stateAverages.Wisconsin = 89.17612755;
stateAverages.Wyoming = 75.95524822;

const providerAverages = [];
providerAverages.enTouch = 108.2390936;
providerAverages['Grande Communications'] = 163.9132517;
providerAverages.RCN = 142.4284045;
providerAverages['Wave Broadband'] = 116.0541961;
providerAverages['AT&T U-verse'] = 77.64610558;
providerAverages['Buckeye Cablevision'] = 78.2794333;
providerAverages.Centurylink = 47.20116647;
providerAverages['Cox Communications'] = 141.1007007;
providerAverages['Frontier Communications'] = 100.1055007;
providerAverages['Google Fiber'] = 155.1474258;
providerAverages['Hughes Network Systems'] = 17.30831042;
providerAverages['LUMOS Networks'] = 71.55052481;
providerAverages['Mediacom Cable'] = 130.5755467;
providerAverages.Metronet = 81.74016177;
providerAverages['Nextlink Broadband'] = 23.65141693;
providerAverages['Optimum Online'] = 137.2792625;
providerAverages['Rise Broadband'] = 21.22719941;
providerAverages['Sonic.net, LLC'] = 3.839916571;
providerAverages.Sparklight = 125.3650137;
providerAverages.Spectrum = 126.5116629;
providerAverages.Starlink = 37.29224647;
providerAverages.Starry = 118.9445071;
providerAverages['Suddenlink Communications'] = 133.2185485;
providerAverages['T-Mobile'] = 43.64504333;
providerAverages['Verizon Fios'] = 144.7671417;
providerAverages.Viasat = 17.6934259;
providerAverages['Windstream Communications'] = 54.36116187;
providerAverages.WideOpenWest = 121.4837676;
providerAverages['Comcast Cable'] = 155.6799445;
providerAverages['Ziply Fiber'] = 101.3127047;

const lang = $('html').attr('lang') === 'es-US' ? 'es' : 'en';

function finishLoading() {
    speedTestStart({
        onSuccess: (data) => {
            speedTestId = data.speedTestId;
        },
    });

    runDownload();
}

function getServerURLs(runAfter = false) {
    serverURLs = ndt7.discoverServerURLs(
        {
            downloadworkerfile:
                '/app/themes/bifrost/vendor-js/ndt7/ndt7-download-worker.min.js',
            uploadworkerfile:
                '/app/themes/bifrost/vendor-js/ndt7/ndt7-upload-worker.min.js',
            metadata: {
                client_name: 'highspeedinternet-speedtest',
            },
        },
        {
            serverChosen(server) {
                serverChosen = true;
                if (mapiFetched) {
                    finishLoading();
                }

                server_city = server.location.city;
                server_country = server.location.country;
                ndtServer = server.machine;
                $('.server-location').html(`${server_city}, ${server_country}`);

                if (runAfter === 'download' && !mapiFetched) {
                    // run the test after getting the connection
                    runDownload();
                } else if (runAfter === 'upload' && !mapiFetched) {
                    runUpload();
                }
            },
        }
    );
}

function getJustfiedSpeed(speedInMB) {
    speedInMB = +speedInMB;
    if (speedInMB < 1) {
        return speedInMB.toFixed(2);
    }
    const e = Math.floor(Math.log(speedInMB) / Math.log(1000));
    return (speedInMB / Math.pow(1000, e)).toFixed(2);
}

function getSplitSpeed(speedInMB) {
    let targetNums = getJustfiedSpeed(speedInMB);
    targetNums = String(targetNums).split('.');
    return targetNums;
}

function checkNumbers(speed) {
    let numDelay = 100;
    $('.circle-chart-num').each((i, e) => {
        if ($(e).data('num') <= speed) {
            setTimeout(() => {
                $(e).addClass('active');
            }, numDelay);
        } else {
            $(e).removeClass('active');
        }
        numDelay = numDelay + 100;
    });
}

function getSpeedUnit(speedInMB) {
    const unit = ['Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps'];
    if (speedInMB < 1) {
        return unit[0];
    }
    const e = Math.floor(Math.log(speedInMB) / Math.log(1000));
    return unit[e];
}

function calcPosition(speed, speedUnitsPos) {
    let pos = 3; // this is where 0 is
    if (speedUnitsPos === 'kbps') {
        pos = 3 + speed * 0.00879;
        // pos start 3, end 12
    } else if (speedUnitsPos !== 'Mbps') {
        // if it's not kbps or Mbps, just max it out
        pos = 76;
    } else if (speed <= 5) {
        pos = 12 + (speed - 1) * 2.375;
        // pos start 12, end 21.5
    } else if (speed <= 10) {
        pos = 21.5 + (speed - 5) * 1.7;
        // pos start 21.5, end 30
    } else if (speed <= 20) {
        pos = 30 + (speed - 10) * 0.75;
        // pos start 30, end 37.5
    } else if (speed <= 40) {
        pos = 37.5 + (speed - 20) * 0.4;
        // pos start start 37.5, end 45.5
    } else if (speed <= 80) {
        pos = 45.5 + (speed - 40) * 0.175;
        // pos start 45.5, end 53.5
    } else if (speed <= 160) {
        pos = 53.5 + (speed - 80) * 0.10625;
        // pos start 53.5, end 62
    } else if (speed <= 320) {
        pos = 62 + (speed - 160) * 0.05625;
        // pos start 62, end 71
        // 320 is on 71
    } else if (speed > 320) {
        pos = 71 + (speed - 320) * 0.028;
    }

    // a catch all just in case
    if (pos >= 76) {
        pos = 76;
    }

    return pos;
}

function pad(num, size) {
    let s = String(num);
    while (s.length < (size || 2)) {
        s = '0' + s;
    }
    return s;
}

// set faster than % based on historical data instead of doing new queries
function calcFaster(checkSpeed) {
    let downloadFaster = 0;

    if (checkSpeed < 0.1) {
        downloadFaster = 1;
    } else if (checkSpeed < 0.5) {
        downloadFaster = 4.6;
    } else if (checkSpeed < 1) {
        downloadFaster = 7.8;
    } else if (checkSpeed < 2) {
        downloadFaster = 12;
    } else if (checkSpeed < 3) {
        downloadFaster = 15.5;
    } else if (checkSpeed < 4) {
        downloadFaster = 18;
    } else if (checkSpeed < 5) {
        downloadFaster = 21;
    } else if (checkSpeed < 10) {
        downloadFaster = 30;
    } else if (checkSpeed < 20) {
        downloadFaster = 40;
    } else if (checkSpeed < 25) {
        downloadFaster = 44;
    } else if (checkSpeed < 30) {
        downloadFaster = 48;
    } else if (checkSpeed < 40) {
        downloadFaster = 54;
    } else if (checkSpeed < 50) {
        downloadFaster = 59;
    } else if (checkSpeed < 60) {
        downloadFaster = 62;
    } else if (checkSpeed < 70) {
        downloadFaster = 65;
    } else if (checkSpeed < 80) {
        downloadFaster = 68;
    } else if (checkSpeed < 90) {
        downloadFaster = 70;
    } else if (checkSpeed < 100) {
        downloadFaster = 73;
    } else if (checkSpeed < 500) {
        downloadFaster = 97;
    } else if (checkSpeed >= 500) {
        downloadFaster = 99;
    }

    return downloadFaster;
}

// speed test is finished
function setFinalScreen() {
    $(
        '.speed-in-progress, .main-chart .circle-chart-num, .main-chart .circle-chart__dot, .main-chart .circle-chart__circle, .current-speed, .speed-activity-upload, .current-speed-units'
    ).hide();

    $('.speed-test-main').addClass('completed');

    $('.speed-test-details__latency').addClass('active');

    if (downloadSpeed !== '-') {
        savedDownloadSpeed = downloadSpeed;
    }

    speedUnits = getSpeedUnit(downloadSpeed);

    completeSpeedTest();

    // set final download stuff
    const finalCircleAmount = calcPosition(downloadSpeed, speedUnits);

    // set values for shareable image
    $('.final-download').html(getJustfiedSpeed(downloadSpeed));
    $('.final-download-units').html(`${speedUnits}`);
    $('.final-speed-circle').css(
        'stroke-dasharray',
        `${finalCircleAmount},100`
    );
    $('.final-speed-dot').css('stroke-dashoffset', `-${finalCircleAmount}`);
    $('.final-ping tspan').html(`${latency} ms`);

    // load final data
    $('.final-provider').html(mm_provider);
    $('.speed-test-v5').addClass('complete');

    $('#test-image').attr('data-testid', speedTestId);
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };
    const today = new Date();
    formattedDate = today.toLocaleDateString('en-US', options);
    $('.final-date').html(`${formattedDate}`);

    justifiedDownload = getJustfiedSpeed(savedDownloadSpeed);
    downloadUnit = getSpeedUnit(savedDownloadSpeed);
    const rangeArray = [
        '0-5 Mbps',
        '5-10 Mbps',
        '10-20 Mbps',
        '20-40 Mbps',
        '40-60 Mbps',
        '60-100 Mbps',
        '100+ Mbps',
    ];

    if (downloadUnit === 'kbps') {
        speedRange = rangeArray[0];
    } else if (justifiedDownload < 5) {
        speedRange = rangeArray[0];
    } else if (justifiedDownload < 10) {
        speedRange = rangeArray[1];
    } else if (justifiedDownload < 20) {
        speedRange = rangeArray[2];
    } else if (justifiedDownload < 40) {
        speedRange = rangeArray[3];
    } else if (justifiedDownload < 60) {
        speedRange = rangeArray[4];
    } else if (justifiedDownload < 100) {
        speedRange = rangeArray[5];
    } else if (justifiedDownload >= 100) {
        speedRange = rangeArray[6];
    }

    // push to datalayer for GA tracking
    dataLayer.push({
        event: 'speedtest',
        download_speed: speedRange,
        provider: mm_provider,
        connection: mm_connection_type,
    });

    if (
        mm_connection_type === 'Cellular' ||
        mm_connection_type === 'null' ||
        mm_country !== 'US'
    ) {
        $('.speed-activity-complete').fadeIn().removeClass('hidden');

        $('.restart-speed-test, .speed-get-image').fadeIn();

        $('.speed-test-end').removeClass('hidden').slideDown(750);
        $('.speed-test-fallback').show();
        $('.speed-test-v5').addClass('finished');
        $('.speed-test-providers').slideDown(750);
    } else {
        $.ajax({
            url: `/wp/wp-admin/admin-ajax.php?action=getAjaxProviders&lang=${lang}`,
            success: (res) => {
                $('.speed-activity-complete').fadeIn().removeClass('hidden');

                $('.restart-speed-test, .speed-get-image').fadeIn();

                $('.speed-test-end').slideDown(750);

                // show crazy egg survey script if enabled
                if (typeof surveyScript === 'function') {
                    surveyScript();
                }

                // if there's something wrong with provider data, it will just return blank string.
                if (!res) {
                    $('.speed-test-fallback').show();
                } else {
                    $('#providersAjax').html(res);
                    $('.speed-test-cable').show();
                    $('.zip-val').html(mm_zip);
                    $('.speed-test-v5').addClass('finished');
                    $('.speed-test-providers').slideDown(750);
                    $.getScript('/app/themes/bifrost-child/dist/js/geo.js');
                    $('#providersAjax').foundation(); // force Foundation to work on ajax content

                    // hide the view full button if there's nothing hidden
                    if (
                        downloadSpeed > 100 &&
                        $('.view-full[data-rel="well"]').is(':visible')
                    ) {
                        $('.view-full[data-rel="both"]').hide();
                    }

                    if (typeof window.addTuneParams === 'function') {
                        window.addTuneParams();
                    }

                    if (typeof initGoLinks === 'function') {
                        initGoLinks();
                    }
                }
            },
            error: (e) => {
                console.log(`Error: ${e}`);
                // show zip look up screen instead
                $('.speed-test-fallback').show();
                $('.speed-test-v5').addClass('finished');
                $('.speed-test-providers').slideDown(750);
            },
        });
    }
}

// make css inline for the sharing image, but only allow specific styles
function inlineStyles(el) {
    const allowedStyles = [
        'fill',
        'transform',
        'transform-origin',
        'stroke',
        'stroke-width',
        'stroke-linecap',
        'stroke-dasharray',
        'stroke-dashoffset',
        'position',
        'font-size',
        'font-weight',
        'top',
        'left',
        'width',
        'height',
        'color',
        'alignment-baseline',
        'text-anchor',
        'font-family',
    ];
    const s = getComputedStyle(el, null);

    allowedStyles.forEach((p) => {
        let propVal = s.getPropertyValue(p);
        if (p === 'transform-origin' && propVal === '0px 0px') {
            propVal = 'center'; // Safari fix
        }
        if (propVal !== null) {
            el.style[p] = propVal;
        }
    });
}

// save the image file of the test results
function saveTestImage(chartID) {
    // build the image
    html2canvas(document.querySelector(`#${chartID}`), {
        width: 640,
        height: 320,
        scale: 1,
    }).then((canvas) => {
        const img = canvas.toDataURL('image/png');
        const finalTestID = $(`#${chartID}`).data('testid');
        const imageData = {
            image: img,
            testID: finalTestID,
        };

        $.ajax({
            url: '/wp/wp-admin/admin-ajax.php?action=saveBase64Image',
            data: imageData,
            type: 'POST',
            success: (s) => {
                $(`#${chartID}`).hide();
                $(`#${chartID}`).before(
                    `<a href="${s}" target="_blank"` +
                        `class="test-share-image" download><img src="${s}" loading="lazy" alt=""></a>`
                );
                $('.speed-image-link').val(`${s}`);
                $('input[name="field[96]"]').val(`${s}`);
                $('.speed-share-info').removeClass('hidden');
                $('.svg-generating-message').hide();
                $('.test-image-box .test-thinking').removeClass('active');
                $('.test-image-box, .final-chart-container').removeClass(
                    'has-svg'
                );
                const fbLink = $('.speed-facebook').attr('href');
                $('.speed-facebook').attr('href', `${fbLink}/${finalTestID}`);
                const twLink = $('.speed-twitter').attr('href');
                $('.speed-twitter').attr('href', `${twLink}/${finalTestID}`);
            },
            error: (e) => {
                console.log('Error: ');
                console.log(e);
                // show zip look up screen instead
            },
        });
    });
}

// set the inline styles on each element
function applyStyles(chartID) {
    // loop through every element of the svg
    $(`#${chartID} .circle-chart`)
        .children()
        .each((i, el) => {
            inlineStyles(el);
            inlineStyles($(`#${chartID}`)[0]);
            if ($(el).children().length > 0) {
                $(el)
                    .children()
                    .each((ci, cel) => {
                        inlineStyles(cel);
                    });
            }
        })
        .promise()
        .done(() => {
            saveTestImage(chartID);
        });
}

/* eslint-disable no-undef */
function updateSpeedEmailValues() {
    $('#input_3_7').val(getJustfiedSpeed(savedDownloadSpeed));
    $('#input_3_8').val(getSpeedUnit(savedDownloadSpeed));
    $('#input_3_9').val(getJustfiedSpeed(uploadSpeed));
    $('#input_3_10').val(getSpeedUnit(uploadSpeed));
    $('#input_3_11').val(latency);
    $('#input_3_12').val(mm_provider);
    $('#input_3_13').val(formattedDate);
    $('#input_3_18').val(mm_city).keyup();
    $('#input_3_19').val(mm_state).keyup();
    $('#input_3_20').val(mm_zip).keyup();
}

function twoDecimals(num) {
    return (Math.round(num * 100) / 100).toFixed(2);
}

const completeSpeedTest = () => {
    if (speedTestId) {
        speedTestComplete({
            speedTestId,
            maxDownloadSpeed,
            maxUploadSpeed,
            finalDownloadSpeed: downloadSpeed,
            finalUploadSpeed: uploadSpeed,
            downElapsed: downloadElapsed,
            upElapsed: uploadElapsed,
            downloadData: downloadSpeedData,
            uploadData: uploadSpeedData,
            ipAddress: user_ip,
            provider: encodeURIComponent(mm_provider),
            server: ndtServer,
            serverCity: server_city,
            serverCountry: server_country,
            connectionType: mm_connection_type,
            latency,
            jitter,
            packetLoss,
        });

        let savedTests = JSON.parse(localStorage.getItem('speedTestData'));
        if (!savedTests) {
            savedTests = {};
        }
        savedTests[speedTestId] = {
            download_speed: downloadSpeed,
            upload_speed: uploadSpeed,
            test_date: Date.now(),
            latency,
        };
        localStorage.setItem('speedTestData', JSON.stringify(savedTests));

        checkSavedTests();
    }
};

function runDownload() {
    ndt7.downloadTest(
        {
            userAcceptedDataPolicy: true,
            downloadworkerfile:
                '/app/themes/bifrost/vendor-js/ndt7/ndt7-download-worker.min.js',
            metadata: {
                client_name: 'highspeedinternet-speedtest',
            },
        },
        {
            downloadMeasurement(data) {
                let speed = 0;

                if (data.Source === 'client') {
                    speed = data.Data.MeanClientMbps;

                    if (typeof speed === 'number' && speed > 0) {
                        downloadSpeedData = [...downloadSpeedData, speed];
                        maxDownloadSpeed =
                            speed > maxDownloadSpeed ? speed : maxDownloadSpeed;

                        speed = twoDecimals(speed);

                        $('.speed-download').html('Testing...');
                        $('.speed-latency').html('Testing...');

                        if (!$('.speed-test-download').hasClass('active')) {
                            $('.hsi-loader').hide().removeClass('active');

                            $('.speed-test-download')
                                .fadeIn(333, () => {
                                    $('.speed-test-download').addClass(
                                        'visible'
                                    );
                                })
                                .addClass('active');
                            let time = 0;
                            $('.circle-chart-num').each((i, e) => {
                                setTimeout(() => {
                                    $(e).fadeIn(200);
                                }, time);
                                time = time + 100;
                            });
                            $('.speed-test-data').removeClass('no-show');
                        }

                        if ($('.speed-test-download').hasClass('visible')) {
                            clearInterval(interval);
                            clearInterval(intervalDecimal);

                            const target = getSplitSpeed(speed);

                            let number = parseFloat(
                                $('.current-speed-main').html()
                            );

                            // prevent the count from being too high
                            if (target[0] - number > 100) {
                                number = target[0] - 100;
                            }

                            checkNumbers(target[0]);

                            $(
                                '.speed-test__data-container[data-for="download"]'
                            ).addClass('active');

                            /* eslint-disable eqeqeq */
                            interval = setInterval(() => {
                                $('.current-speed-main').html(number);

                                if (number == target[0]) {
                                    clearInterval(interval);
                                }

                                if (target[0] < number) {
                                    number = number - 1;
                                } else {
                                    number = number + 1;
                                }
                            }, 20);

                            let decimal = parseFloat(
                                $('.current-speed-decimal').html()
                            );
                            if (target.length === 1) {
                                $('.current-speed-decimal').html('');
                                $('.current-speed-dot').hide();
                            } else {
                                intervalDecimal = setInterval(() => {
                                    $('.current-speed-decimal').html(
                                        pad(decimal, 2)
                                    );
                                    if (decimal == target[1]) {
                                        clearInterval(intervalDecimal);
                                    }

                                    if (target[1] < decimal) {
                                        decimal = decimal - 1;
                                    } else {
                                        decimal = decimal + 1;
                                    }
                                }, 20);
                            }

                            // $('.current-speed').html(getJustfiedSpeed(speed));
                            speedUnits = getSpeedUnit(speed);
                            $('.current-speed-units').html(speedUnits);
                            circleAmount = calcPosition(speed, speedUnits);
                            // to force animations
                            $('.main-chart .circle-chart__circle').css(
                                'stroke-dasharray',
                                `${circleAmount},100`
                            );
                            $('.main-chart .circle-chart__dot').css(
                                'stroke-dashoffset',
                                `-${circleAmount}`
                            );
                        }
                    }
                }
            },
            downloadComplete(data) {
                // (bytes/second) * (bits/byte) / (megabits/bit) = Mbps

                clearInterval(interval);
                clearInterval(intervalDecimal);

                downloadSpeed = data.LastClientMeasurement.MeanClientMbps;
                downloadElapsed = data.LastClientMeasurement.ElapsedTime;
                packetLoss = data.LastServerMeasurement.TCPInfo.Lost;

                // option to force a final download speed for testing purposes
                if (getParameterByName('force_download') !== null) {
                    downloadSpeed = getParameterByName('force_download');
                }

                $('.speed-test__data-container[data-for="download"]')
                    .removeClass('active')
                    .addClass('removing');

                latency = Math.round(
                    data.LastServerMeasurement.BBRInfo.MinRTT / 1000
                );
                jitter = Math.round(
                    data.LastServerMeasurement.TCPInfo.RTTVar / 1000
                );
                speedUnits = getSpeedUnit(downloadSpeed);

                // set speed for FAQ questions
                if (downloadSpeed >= providerAverages[mm_provider]) {
                    $('.speed-provider-faster').removeClass('hidden');
                } else {
                    $('.speed-provider-slower').removeClass('hidden');
                }

                if (downloadSpeed >= stateAverages[mm_full_state]) {
                    $('.speed-state-faster').removeClass('hidden');
                } else {
                    $('.speed-state-slower').removeClass('hidden');
                }

                $('.speed-after-run').removeClass('hidden');
                $('.speed-before-run').hide();

                $('.speed-download').html(
                    `${getJustfiedSpeed(downloadSpeed)} ${speedUnits}`
                );
                $('.speed-latency').html(`${latency} ms`);
                const fasterThan = calcFaster(downloadSpeed);
                $('.faster-than').html(`${fasterThan}%`);
                $('.faster-than-first').hide();
                $('.faster-than-second').fadeIn();

                $('.speed-upload').html('Testing...');

                $('.main-chart .circle-chart__circle').css(
                    'stroke-dasharray',
                    ''
                );
                $('.main-chart .circle-chart__dot').css(
                    'stroke-dashoffset',
                    ''
                );
                $(
                    '.speed-in-progress, .current-speed, .speed-activity-download, .current-speed-units'
                ).fadeOut();
                setTimeout(() => {
                    $('.current-speed-main').html('00');
                    $('.current-speed-decimal').html('00');
                    $('.current-speed-units').html('');
                    $('.main-chart .circle-chart-num').removeClass('active');
                    $(
                        '.speed-in-progress__upload, .current-speed, .speed-activity-upload, .current-speed-units'
                    ).fadeIn();
                }, 1000);

                setTimeout(() => {
                    runUpload();
                }, 1100);

                const serverBw =
                    (data.LastServerMeasurement.BBRInfo.BW * 8) / 1000000;
                const clientGoodput = data.LastClientMeasurement.MeanClientMbps;
                console.log(
                    `Download test is complete:
      Instantaneous server bottleneck bandwidth estimate: ${serverBw} Mbps
      Mean client goodput: ${clientGoodput} Mbps`
                );
                // document.getElementById('download').innerHTML = 'Download: ' + clientGoodput.toFixed(2) + ' Mb/s';
            },
            error(err) {
                console.log('Error while running the test:', err.message);
                getServerURLs();
            },
        },
        serverURLs
    );
}

function runUpload() {
    ndt7.uploadTest(
        {
            userAcceptedDataPolicy: true,
            uploadworkerfile:
                '/app/themes/bifrost/vendor-js/ndt7/ndt7-upload-worker.min.js',
            metadata: {
                client_name: 'highspeedinternet-speedtest',
            },
        },
        {
            uploadMeasurement(data) {
                let speed = 0;

                if (
                    data.Source === 'server' &&
                    data.Data.hasOwnProperty('TCPInfo')
                ) {
                    // make sure we have the data we need
                    speed = parseFloat(
                        (data.Data.TCPInfo.BytesReceived /
                            data.Data.TCPInfo.ElapsedTime) *
                            8
                    );

                    if (!isNaN(speed) && speed > 0) {
                        uploadSpeedData = [...uploadSpeedData, speed];
                        maxUploadSpeed =
                            speed > maxUploadSpeed ? speed : maxUploadSpeed;

                        speed = twoDecimals(speed);

                        $('.speed-test-download')
                            .fadeIn(333, () => {
                                $('.speed-test-download').addClass('visible');
                            })
                            .addClass('active');

                        if (!$('.speed-test-download').hasClass('active')) {
                            $('.hsi-loader').hide().removeClass('active');

                            $('.speed-test-upload')
                                .fadeIn(333, () => {
                                    $('.speed-test-upload').addClass('visible');
                                })
                                .addClass('active');

                            let time = 0;
                            $('.circle-chart-num').each((i, e) => {
                                setTimeout(() => {
                                    $(e).fadeIn(200);
                                }, time);
                                time = time + 100;
                            });
                            $('.speed-test-data').removeClass('no-show');
                        }

                        if ($('.speed-test-download').hasClass('visible')) {
                            clearInterval(interval);
                            clearInterval(intervalDecimal);

                            const target = String(speed).split('.');

                            let number = parseFloat(
                                $('.current-speed-main').html()
                            );

                            $(
                                '.speed-test__data-container[data-for="upload"]'
                            ).addClass('active');

                            // prevent the count from being too high
                            if (target[0] - number > 100) {
                                number = target[0] - 100;
                            }

                            checkNumbers(target[0]);

                            /* eslint-disable eqeqeq */
                            interval = setInterval(() => {
                                $('.current-speed-main').html(number);

                                if (number == target[0]) {
                                    clearInterval(interval);
                                }

                                if (target[0] < number) {
                                    number = number - 1;
                                } else {
                                    number = number + 1;
                                }
                            }, 10);

                            let decimal = parseFloat(
                                $('.current-speed-decimal').html()
                            );
                            if (isNaN(decimal)) {
                                decimal = '00';
                            }

                            if (target.length === 1) {
                                $('.current-speed-decimal').html('');
                                $('.current-speed-dot').hide();
                            } else {
                                intervalDecimal = setInterval(() => {
                                    $('.current-speed-decimal').html(
                                        pad(decimal, 2)
                                    );
                                    if (decimal == target[1]) {
                                        clearInterval(intervalDecimal);
                                    }

                                    if (target[1] < decimal) {
                                        decimal = decimal - 1;
                                    } else {
                                        decimal = decimal + 1;
                                    }
                                }, 10);
                            }

                            // $('.current-speed').html(getJustfiedSpeed(speed));
                            speedUnits = getSpeedUnit(speed);
                            $('.current-speed-units').html(speedUnits);
                            circleAmount = calcPosition(speed, speedUnits);
                            // to force animations
                            $('.main-chart .circle-chart__circle').css(
                                'stroke-dasharray',
                                `${circleAmount},100`
                            );
                            $('.main-chart .circle-chart__dot').css(
                                'stroke-dashoffset',
                                `-${circleAmount}`
                            );
                        }
                    }
                }
            },
            uploadComplete(data) {
                const bytesReceived =
                    data.LastServerMeasurement.TCPInfo.BytesReceived;
                const elapsed = data.LastServerMeasurement.TCPInfo.ElapsedTime;
                uploadSpeed = twoDecimals(
                    parseFloat((bytesReceived * 8) / elapsed)
                );
                uploadElapsed = data.LastClientMeasurement.ElapsedTime;

                $('.speed-test__data-container[data-for="upload"]').removeClass(
                    'active'
                );
                $('.speed-test__data-container[data-for="upload"]').addClass(
                    'removing'
                );
                $('.speed-in-progress__upload').hide();

                // for the sharing image
                setFinalScreen();
                $('.speed-upload, .speed-upload-final').html(
                    `${getJustfiedSpeed(uploadSpeed)} ${getSpeedUnit(
                        uploadSpeed
                    )}`
                );
                $('.final-upload').html(
                    `Upload: ${getJustfiedSpeed(uploadSpeed)} ${getSpeedUnit(
                        uploadSpeed
                    )}`
                );

                console.log(
                    `Upload test completed in ${(elapsed / 1000000).toFixed(2)}s
        Mean server throughput: ${uploadSpeed} Mbps`
                );
            },
            error(err) {
                console.log('Error while running the test:', err.message);
                getServerURLs();
            },
        },
        serverURLs
    );
}

function checkSavedTests() {
    const savedTests = JSON.parse(localStorage.getItem('speedTestData'));
    if (savedTests) {
        $('.previous-tests-table tbody:last-of-type').html(''); // clear out old data just in case
        for (const test in savedTests) {
            if (savedTests[test]) {
                const savedTestDownloadSpeed = getJustfiedSpeed(
                    savedTests[test].download_speed
                );
                const savedTestDownloadUnit = getSpeedUnit(
                    savedTests[test].download_speed
                );
                let savedTestUploadSpeed = '-';
                let savedTestUploadUnit = '';
                if (savedTests[test].upload_speed) {
                    savedTestUploadSpeed = getJustfiedSpeed(
                        savedTests[test].upload_speed
                    );
                    savedTestUploadUnit = getSpeedUnit(
                        savedTests[test].upload_speed
                    );
                }

                const d = new Date(savedTests[test].test_date);
                let hours = d.getHours();
                let ampm = 'am';
                let minutes = d.getMinutes();
                if (hours > 12) {
                    hours = hours - 12;
                    ampm = 'pm';
                } else if (hours === 0) {
                    hours = 12;
                }

                const month = d.getMonth() + 1;

                if (minutes < 10) {
                    minutes = `0${minutes}`;
                }

                const rowHTML =
                    '<tr>' +
                    `<td>${month}/${d.getDate()}/${d.getFullYear()} ${hours}:${minutes}${ampm}</td>` +
                    `<td>${savedTestDownloadSpeed} ${savedTestDownloadUnit}</td>` +
                    `<td>${savedTestUploadSpeed} ${savedTestUploadUnit}</td>` +
                    `<td>${savedTests[test].latency} ms</td>` +
                    '</tr>';

                $('.previous-tests-table tbody:last-of-type').prepend(rowHTML);
            }
        }
        $('.show-saved-tests').removeClass('hidden');
    }
}

function setMapiData() {
    if (isLocalStorage()) {
        $.ajax({
            dataType: 'json',
            url: `/wp/wp-admin/admin-ajax.php?action=setGeoIP`,
            success: (res) => {
                if (getParameterByName('force_provider') !== null) {
                    res.MM_ISP = getParameterByName('force_provider');
                }

                if (getParameterByName('force_state') !== null) {
                    res.MM_FULL_STATE = getParameterByName('force_state');
                }

                localStorage.setItem('MM_ZIP', res.MM_ZIP);
                localStorage.setItem('MM_COUNTRY_CODE', res.MM_COUNTRY_CODE);
                localStorage.setItem('MM_ISP', res.MM_ISP);
                localStorage.setItem(
                    'MM_CONNECTION_TYPE',
                    res.MM_CONNECTION_TYPE
                );
                localStorage.setItem('MM_CITY_NAME', res.MM_CITY_NAME);
                localStorage.setItem('MM_REGION_CODE', res.MM_REGION_CODE);
                localStorage.setItem('USER_IP', res.USER_IP);
                localStorage.setItem('MM_DATE', new Date().getDate());
                localStorage.setItem('MM_FULL_STATE', res.MM_FULL_STATE);

                window.mm_provider = res.MM_ISP;
                window.mm_zip = res.MM_ZIP;
                window.mm_city = res.MM_CITY_NAME;
                window.mm_state = res.MM_REGION_CODE;
                window.mm_full_state = res.MM_FULL_STATE;
                window.mm_connection_type = res.MM_CONNECTION_TYPE;
                window.mm_country = res.MM_COUNTRY_CODE;
                window.user_ip = res.USER_IP;

                mapiFetched = true;
                if (serverChosen) {
                    finishLoading();
                }

                $('.speed-provider').html(window.mm_provider);

                if (window.mm_full_state) {
                    $('.speed-test-faq__state').removeClass('hidden');
                    $('.speed-state').html(window.mm_full_state);
                    $('.speed-state-average').html(
                        `${parseFloat(
                            stateAverages[window.mm_full_state]
                        ).toFixed(2)} Mbps`
                    );
                }

                if (providerAverages[window.mm_provider]) {
                    $('.speed-test-faq__provider').removeClass('hidden');
                    $('.speed-provider-average').html(
                        `${parseFloat(
                            providerAverages[window.mm_provider]
                        ).toFixed(2)} Mbps`
                    );
                }

                $('.user-zip').html(window.mm_zip);
                $('.user-ip').html(window.user_ip);
            },
            error: () => {
                console.log('MAPI lookup error');

                mapiFetched = true;
                if (serverChosen) {
                    finishLoading();
                }
            },
        });
    } else {
        mapiFetched = true;
    }
}

$(function () {
    setMapiData();

    $('body').on('keyup', '.street-field input', (e) => {
        if ($(e.currentTarget).val() !== '') {
            $('.street-depend').slideDown();
        } else if ($(e.currentTarget).val() === '') {
            $('.street-depend').slideUp();
        }
    });

    $('#field88').mask('00000');

    if ($('#finalChart').length > 0 && !$('#finalChart').data('has-image')) {
        applyStyles('finalChart');
    }

    $('.start-speed-test').click(() => {
        $('.speed-test-intro').hide();
        $('.hsi-loader').fadeIn().addClass('active');
        $('.speed-test-data').addClass('no-show');

        getServerURLs();
    });

    checkSavedTests();

    $('.speed-test-details__show').click(() => {
        $('.speed-test-details__show').toggleClass('active');
        $('.speed-test-details__details').slideToggle();
    });

    $('.speed-test-faq').click((e) => {
        $(e.currentTarget).toggleClass('active');
        $(e.currentTarget).next('.speed-test-faq__answer').slideToggle();
    });

    $('span[data-tooltip]').on('click', (e) => {
        const tipID = $(e.currentTarget).data('toggle');
        $(`.tooltip:not(#${tipID})`).css({
            display: 'none',
            top: '',
            left: '',
            position: '',
        });
        e.stopPropagation();
    });

    deviceRegistration();

    $('.speed-get-image').click(() => {
        if ($('.test-image-container .test-share-image').length < 1) {
            $('.test-image-box .test-thinking').addClass('active');
            setTimeout(() => {
                // has to be in timeout to wait for the lightbox to open
                applyStyles('test-image');
            }, 666);
        }
    });

    // restart speed test
    $(document).on('click', '.speed-test-v5.finished .main-chart', () => {
        // reset all the values
        $('.speed-test-v5').removeClass('finished');
        $('.speed-test-download').removeClass('active').removeClass('visible');
        $('.speed-test-providers').slideUp();
        $(
            '.speed-test-end, .speed-test-download, .speed-test-cable, .speed-test-fallback, .speed-activity-complete, .restart-speed-test, .speed-get-image'
        ).css('display', 'none');
        $('.speed-test__data-container').removeClass('removing');
        $(
            '.current-speed, .speed-activity-download, .main-chart .circle-chart__circle, .main-chart .circle-chart__dot'
        ).show();
        $('.speed-test-data').addClass('no-show');
        $('.speed-latency, .speed-upload, .speed-upload').html('&nbsp;');
        $('.current-speed-units').html('');
        $('.current-speed-main').html('00');
        $('.current-speed-decimal').html('00');
        $('.speed-in-progress, .current-speed-dot').show();
        $('.circle-chart__circle').css('stroke-dasharray', '0, 100');
        $('.circle-chart__dot').css('stroke-dashoffset', '0');

        $('html, body').animate(
            { scrollTop: $('#speed-test-banner').offset().top },
            300
        );

        $('.hsi-loader').show().addClass('active');

        savedDownloadSpeed = '';

        finishLoading();

        checkSavedTests();

        // reset sharing image
        $('.svg-generating-message, #test-image').show();
        $('.test-share-image').remove();
        $('.speed-share-info').addClass('hidden');
        $('.test-image-box, .final-chart-container').addClass('has-svg');
        $('#test-image').removeData('testid');
    });

    // email sharing form
    $('.speed-email').click(() => {
        $('.share-direct').hide();
        $('.share-email').show();
        updateSpeedEmailValues();
    });

    $('.speed-direct').click(() => {
        $('.share-email').hide();
        $('.share-direct').show();
    });
});
